module.exports = __webpack_public_path__ + "img/1554387700.78c18d71.jpg";